export default __webpack_public_path__ + "static/media/@rafaelapinheirooficial.98fb9869.webp";